module.exports = __webpack_public_path__ + "static/img/beian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/beian.png
// module id = RNXm
// module chunks = 3